import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const removeSavedViewCalculation: YJSChangeHandler<
  DatabaseChangeType.REMOVE_SAVED_VIEW_CALCULATION
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const view = db.viewsById[change.viewId];

    if (view) {
      view.removeCalculation(change.fieldId);
    }
  });
};
